import { agentDisplayName, type AgentId } from '@/config/env'

import { AgentAvatar } from './AgentAvatar'

interface ThinkingIndicatorProps {
  agentId: AgentId
}

export function ThinkingIndicator({ agentId }: ThinkingIndicatorProps) {
  return (
    <div
      data-slot="thinking-indicator"
      className="flex items-center gap-1.5 mb-4">
      <AgentAvatar agentId={agentId} className="size-10" thinking />
      <span className="text-shimmer-gradient font-medium text-sm leading-4 tracking-[-0.28px]">
        {agentDisplayName(agentId)} is thinking...
      </span>
    </div>
  )
}
